// Decorative gold nested-arch divider (SVG). Purely visual.
export default function ArchDivider({ className = "", flip = false }) {
  return (
    <svg
      className={`arch-divider ${className}`}
      viewBox="0 0 240 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      style={flip ? { transform: "scaleY(-1)" } : {}}
    >
      <path d="M20 60 A 100 100 0 0 1 220 60" stroke="currentColor" strokeWidth="1" opacity="0.7" />
      <path d="M40 60 A 80 80 0 0 1 200 60" stroke="currentColor" strokeWidth="1" opacity="0.55" />
      <path d="M60 60 A 60 60 0 0 1 180 60" stroke="currentColor" strokeWidth="1" opacity="0.4" />
      <path d="M80 60 A 40 40 0 0 1 160 60" stroke="currentColor" strokeWidth="1" opacity="0.25" />
      <circle cx="120" cy="60" r="2.5" fill="currentColor" />
    </svg>
  );
}
